<template>
  <div class="editor-wrap" v-if="activeComponent && isSupportedEditor">
    <component
      :is="activeComponent"
      :node="selectedNode"
      :scene-id="sceneId"
      @preview="$emit('preview', $event)"
      @show-error-popup="$emit('showErrorPopup', $event)"
      :key="selectedNode.placeholder?.id || selectedNode.id"
    />

    <div class="tags-wrap">
      <span>Tags (Separate by ;) </span>
      <IdmInput
        v-if="showTags"
        :placeholder="'Intro;Outro'"
        :tags="true"
        :tagsList="selectedNode.tags"
        @inputTags="inputTags"
        data-test="editors-tags-input"
      />
    </div>

    <div class="description-wrap">
      <span>Description</span>
      <IdmTextarea
        :text="selectedNode.description"
        :placeholder="'Add description ...'"
        @input="inputDescription"
        data-test="placeholder-description-textarea"
      />
    </div>
  </div>
</template>

<script>
import textEditor from '@/components/editors/text/index.vue';
import mediaEditor from '@/components/editors/media/index.vue';
import audioEditor from '@/components/editors/audio/index.vue';
import { useBuilderStore } from "@/stores/builderStore";
import sceneCacheStorage from '@/helper/cache';
import _ from 'lodash';
export default {
  name: 'editors',

  props: ['selectedNode', 'sceneId'],

  components: {
    textEditor,
    mediaEditor,
    audioEditor,
  },

  data() {
    return {
      showTags: true,
      nodeChanged: false,
      inputChanged: false,
      supportedTypes: ['textEditor', 'mediaEditor', 'audioEditor'],
    };
  },

  watch: {
    'selectedNode.key'(newKey, oldKey) {
      this.nodeChanged = true;
    },
    'selectedNode.tags'(newTags, oldTags) {
      const tagsEqual = _.isEqual(newTags.sort(), oldTags.sort());

      if (this.inputChanged) {
        this.inputChanged = false;
        return;
      }

      if (this.nodeChanged || !tagsEqual) {
        this.rerenderTags();
      }
    },
  },

  computed: {
    builderStore() {
      return useBuilderStore();
    },
    scene() {
      return this.builderStore.scene;
    },
    activeComponent() {
      const media =
        this.selectedNode.media_type === 'video' ||
        this.selectedNode.media_type === 'color' ||
        this.selectedNode.media_type === 'image';
      return this.selectedNode
        ? media
          ? 'mediaEditor'
          : this.selectedNode.media_type + 'Editor'
        : null;
    },
    isSupportedEditor() {
      return this.supportedTypes.indexOf(this.activeComponent) >= 0;
    },
  },

  methods: {
    rerenderTags() {
      this.showTags = false;
      this.$nextTick(() => {
        this.nodeChanged = false;
        this.showTags = true;
      });
    },
    inputTags(tagsData) {
      const tags = _.reject(tagsData, (tag) => {
        return tag === '';
      });
      this.inputChanged = true;
      this.builderStore.updateNodeTags({
        node: this.selectedNode,
        tags: tags,
      });
      sceneCacheStorage.updateSceneCache(this.scene);
    },
    inputDescription(e) {
      this.builderStore.updateNodeDescription({
        node: this.selectedNode,
        description: e.target.value.trim(),
      });
      sceneCacheStorage.updateSceneCache(this.scene);
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-wrap,
.description-wrap {
  color: var(--dark-500);
  margin-top: 24px;
  padding-top: 21px;
  border-top: 1px solid #dbdbdb;

  .idm-input-container,
  .idm-textarea {
    margin-top: 11px;
  }
}
</style>
